import { createContext } from 'react';
import { CardPaginationFilter } from '@shared/api/providers/cardPagination';

export interface CardActionsState {
  active: boolean;
  setActive(active: boolean): void;
}

export interface CardFilterState {
  appliedFilters: CardPaginationFilter[];
  setAppliedFilters(filters: CardPaginationFilter[]): void;
  excludedFieldNames: string[];
  setExcludedFieldNames(fieldNames: string[]): void;
}

const defaultCardActionsState: CardActionsState = {
  active: false,
  setActive: () => {},
};

const defaultCardFilterState: CardFilterState = {
  appliedFilters: [],
  setAppliedFilters: () => {},
  excludedFieldNames: [],
  setExcludedFieldNames: () => {},
};

export const CardActionsStateContext = createContext<CardActionsState>(defaultCardActionsState);
export const CardFilterStateContext = createContext<CardFilterState>(defaultCardFilterState);
